<template>
    <div>
        <el-button type="primary"
                   @click="startTour"
                   :disabled="!tourAvailable">
            {{ $t('concordanceSearchTour.tourName') }}
        </el-button>

        <el-popover :visible="tourPopover"
                    :virtual-ref="popoverTarget"
                    virtual-triggering
                    placement="bottom"
                    :width="400"
                    popper-class="concordance-tour-popover">
            <div class="popover-wrapper">
                <h4>{{ $t('concordanceSearchTour.openSearch') }}</h4>
                <p>{{ $t('concordanceSearchTour.openSearchDescription') }}</p>

                <el-button type="primary"
                           @click="continueTour">
                    {{ $t('generic.next') }}
                </el-button>
            </div>
        </el-popover>

        <el-tour v-model="tourStart"
                 :target-area-clickable="false">
            <el-tour-step v-for="step in tourSteps"
                          :key="step.id"
                          :target="step.target"
                          :title="$t(step.title)"
                          :description="$t(step.description)" />
        </el-tour>
    </div>
</template>

<script lang="ts">
    import { defineComponent, nextTick } from 'vue';
    import { userGuideService } from '../userGuideService'

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                tourPopover: false,
                tourStart: false,
                tourSteps: userGuideService.getConcordanceSearch(),
                popoverTarget: null as HTMLElement | null,
            };
        },
        methods: {
            startTour() {
                this.hideShortcutsPopup();
                this.popoverTarget = document.getElementById("concordance-search-button");
                this.tourPopover = true;
            },
            hideShortcutsPopup() {
                const shortcutButton = document.getElementById("shortcut-button");
                if (shortcutButton != null) {
                    shortcutButton.click();
                }
            },
            async continueTour() {
                this.tourPopover = false;

                this.clickConcordanceButton();
                await nextTick();
                await new Promise(resolve => setTimeout(resolve, 300));
                this.tourStart = true;
            },
            clickConcordanceButton() {
                const result = document.getElementById("concordance-search-button");
                if (result != null) {
                    result.click();
                }
            },
        },
    })
</script>

<style scoped>
    .popover-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
        padding: 8px;
    }

        .popover-wrapper h4 {
            margin: 0;
        }

        .popover-wrapper p {
            text-align: center;
            margin: 0;
        }
</style>